export class User {

    id:string = null;
    email:string = null;
    username:string = null;
    password:string = "123";
    name:string = null;
    role:string = null;
    visits:any = null;
    active : boolean = false;

    getId() {
        return this.id;
    }

    setId(id : string) {
        this.id = id;
    }

    getVisits() {
        return this.visits;
    }

    setVisits(list : any) {
        this.visits = list;
    }

    getActive() {
        return this.active;
    }

    setActive(active : boolean) {
        this.active = active;
    }

    getEmail() {
        return this.email;
    }

    setEmail(email : string) {
        this.email = email;
    }

    getUsername() {
        return this.username;
    }

    setUsername(username : string) {
        this.username = username;
    }

    getName() {
        return this.name;
    }

    setName(name : string) {
        this.name = name;
    }

    getRole() {
        return this.role;
    }

    setRole(role : string) {
        this.role = role;
    }

    setPassword(pwd : string) {
        this.password = pwd;
    }


    reset(){
        this.setId(null);
        this.setName(null);
        this.setRole(null);
        this.setEmail(null);
        this.setUsername(null);
        this.setActive(false);
    }
    
}